import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { DisplayType } from "models/enums/style";
import { FAQConstants, IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { ActionLinkButton, ExpandableViewPanel, Icon, StaticInfoMessage } from "components/common";
import { Grid } from "@mui/material";
import { FAQArticleLink, useFAQArticleLink } from "components/support";
import RevisorFAQWidgetFooter from "./footer";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";
import { useSelector } from "react-redux";
import { AppState } from "store";
import { LocaleEnums } from "models/enums";

const RevisorFAQWidget: React.FC = (props) => {
  const language = useSelector((store: AppState) => store.common.locale.language);

  const defaultArticles: WintSuperkollAPIModel.FAQItem[] = [
    {
      title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SupportIssue.RevisorFAQHelpItem1Title),
      url: `${FAQConstants.FAQUrl}/${FAQConstants.FAQPageUrl}/${FAQConstants.RevisorArticle1Url}`,
    },
    {
      title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SupportIssue.RevisorFAQHelpItem2Title),
      url: `${FAQConstants.FAQUrl}/${FAQConstants.FAQPageUrl}/${FAQConstants.RevisorArticle2Url}`,
    },
    {
      title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SupportIssue.RevisorFAQHelpItem3Title),
      url: `${FAQConstants.FAQUrl}/${FAQConstants.FAQPageUrl}/${FAQConstants.RevisorArticle3Url}`,
    },
  ];

  const { getFAQUrl } = useFAQArticleLink();

  const onClickNavigateToAllFAQ = () => {
    window.open(getFAQUrl(`${FAQConstants.FAQUrl}/${FAQConstants.RevisorArticlesAllUrl}`), "_blank");
  };

  return (
    <ExpandableViewPanel
      title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.FaqText)}
      icon={IconDefinitionConstants.WCommentDots}
      expanded
      footerLeftContent={<RevisorFAQWidgetFooter />}
      className={cssExports.revisorFaqWidget}
    >
      <Grid container rowGap={2}>
        {language === LocaleEnums.LocaleType.en ? (
          <Grid item marginBottom={2}>
            <StaticInfoMessage>
              Note: The answers provided have been auto-translated using Google Translate. This process may introduce
              errors or inconsistencies. Please consider this when interpreting the information.
            </StaticInfoMessage>
          </Grid>
        ) : (
          <></>
        )}
        <Grid container>
          {defaultArticles.map((article, index) => (
            <FAQArticleLink key={article.id ?? index} article={article} display="filled" />
          ))}
        </Grid>
        <ActionLinkButton
          endIcon={<Icon icon={IconDefinitionConstants.WOpenExternal} displayType={DisplayType.Info} />}
          onClick={onClickNavigateToAllFAQ}
        >
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SupportIssue.ViewAllQuestions)}
        </ActionLinkButton>
      </Grid>
    </ExpandableViewPanel>
  );
};

export default RevisorFAQWidget;
